<template>
  <section>
    <div class="page-head">
      <div>
        <h1 class="page-title">Seleccionar grupo</h1>
        <p class="page-sub">Haz clic en un grupo para ver su información como jefe (modo SUPER)</p>
      </div>
    </div>

    <div class="grupos-grid">
      <div v-for="g in grupos" :key="g.id" class="grupo-card" @click="seleccionarGrupo(g)" role="button" tabindex="0" @keydown.enter="seleccionarGrupo(g)"
           :style="{ borderLeftColor: accentColor(g.id) }">
        <div class="grupo-card-header">
          <div class="grupo-emoji" :style="{ background: accentColor(g.id), color: '#fff' }" aria-hidden="true">
            <!-- Modern SVG group icon (colored by container background) -->
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M16 11c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3z" fill="white"/>
              <path d="M8 11c1.657 0 3-1.343 3-3S9.657 5 8 5 5 6.343 5 8s1.343 3 3 3z" fill="white"/>
              <path d="M8 13c-2.33 0-7 1.17-7 3.5V19h7v-6z" fill="rgba(255,255,255,0.12)"/>
              <path d="M16 13c.29 0 .57.02.85.05C18.33 13.16 22 14.33 22 16.5V19h-6v-6z" fill="rgba(255,255,255,0.12)"/>
            </svg>
          </div>
          <div>
            <h3 class="grupo-nombre">{{ g.nombre }}</h3>
            <div class="grupo-jefe">Jefe: <strong>{{ g.jefe || '—' }}</strong></div>
          </div>
        </div>
        <div class="grupo-card-body">
          <p class="grupo-info">Ver todo lo del grupo</p>
        </div>
      </div>
      <div v-if="grupos.length === 0" class="no-grupos">No hay grupos aún.</div>
    </div>
  </section>
</template>

<script>
import HttpService from '@/Servicios/HttpService'

export default {
  name: 'SeleccionarGrupoComponent',
  data() {
    return {
      grupos: [],
      mensaje: ''
    }
  },
  created() {
    this.loadGrupos()
    window.addEventListener('gruposUpdated', this.loadGrupos)
  },
  beforeDestroy() {
    window.removeEventListener('gruposUpdated', this.loadGrupos)
  },
  methods: {
    async loadGrupos() {
      try {
        const data = await HttpService.obtenerConConsultas('grupos.php', { accion: 'obtener' })
        this.grupos = Array.isArray(data) ? data.map(g => ({ id: Number(g.id), nombre: g.nombre || '', jefe: g.jefe || g.jefeId || '' })) : []
      } catch (e) {
        console.error('Error cargando grupos:', e)
        this.grupos = []
      }
    },
    seleccionarGrupo(g){
      if(!g || !g.id) return
      const id = Number(g.id)
      localStorage.setItem('grupoSeleccionado', String(id))
      localStorage.setItem('grupoSeleccionadoNombre', g.nombre || '')
      localStorage.setItem('grupoSeleccionadoJefe', g.jefe || '')
      localStorage.setItem('superActuandoComoGrupo', '1')
      try { window.dispatchEvent(new CustomEvent('grupoSeleccionadoChanged', { detail: id })) } catch(e){ void e }
      try { this.$router.push({ path: '/' }) } catch(e){ void e }
    }
    ,
    accentColor(id){
      try{
        const palette = ['#7C3AED','#06B6D4','#F59E0B','#EF4444','#10B981','#8B5CF6','#F43F5E']
        const idx = Number(id) || 0
        return palette[idx % palette.length]
      } catch(e){ return '#7C3AED' }
    }
  }
}
</script>

<style scoped>
.grupos-grid{
  display:grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap:1rem;
  margin-top:1rem;
}
.grupo-card{
  background:#fff;
  border:1px solid #e9ecf5;
  border-radius:14px;
  padding:1rem 1rem 1.1rem 1rem;
  box-shadow: 0 1px 2px rgba(16,24,40,.04), 0 8px 24px -14px rgba(16,24,40,.10);
  cursor:pointer;
  transition: transform .14s ease, box-shadow .14s ease;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
}
.grupo-card{ border-left: 6px solid rgba(124,58,237,0.12) }
.grupo-card:focus, .grupo-card:hover{ transform: translateY(-4px); box-shadow: 0 14px 32px -12px rgba(76,58,180,.22); outline:none }
.grupo-card-header{ margin-bottom:0.6rem; display:flex; align-items:center }
.grupo-emoji{ font-size:1.6rem; margin-right:0.6rem }
.grupo-emoji{ width:40px; height:40px; border-radius:50%; display:flex; align-items:center; justify-content:center; box-shadow: 0 6px 18px rgba(0,0,0,0.06); }
.grupo-nombre{ margin:0; font-size:1.05rem }
.grupo-jefe{ color:#666; font-size:0.9rem; margin-top:0.15rem }
.grupo-info{ color:#888; font-size:0.95rem }
.no-grupos{ grid-column:1/-1; text-align:center; color:#777; padding:2rem; background:#fff; border-radius:14px; border:1px solid #e9ecf5 }
</style>
